import React, { useEffect, useState, useRef } from "react";
import { notification, Select, Pagination, Input } from "antd";

import { Link, useNavigate } from "react-router-dom";

import LoadingEffect from "../../../../components/Loading/LoadingEffect";

import {userList,createRequest}  from  "../../../../controllers/V1/invoice/invoiceControllers";
import { faArrowLeft, faCheckCircle, faInfoCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { list as getGeneralData} from  '../../../../controllers/V1/generalDataController';
const UserListEditPage = () => {
  
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [today] = useState(new Date().toISOString().split("T")[0]);
  const [ADDEDITDATA, setAddEditSata] = useState({
    start_time : '21:31:00',
    end_time : '21:30:00'
  });
  const [ALLUSERSLIST, setAllUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [OPTIONS, setOptions] = useState([]);
  const [optionsLoading, setOptionsLoading] = useState(false);
  const [search_by, setSearchBy] = useState('');
  const handleSearchBy = (e)=>setSearchBy(e.target.value);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading, please wait...');

  const [invoiceData, setInvoiceData] = useState({});

  const [retailerList, setRetailerList] = useState([]);

  const [selectAll, setSelectAll] = useState(false);
  const toggleSelectAll = ()=>setSelectAll(!selectAll);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  
  // Local search state
  const [searchTerm, setSearchTerm] = useState('');

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const invoiceDataChange = (e) => {
    setInvoiceData((pre)=>({
      ...pre,
      [e.target.name] : e.target.value 
    }))
  }; 

  const handleBulkRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData(e?.target);
      let msg = "";
      let status = true;

      // Validation
      if(!selectedUsers || selectedUsers.length === 0){
        msg = 'Please select at least one Sales Person.';
        status = false;
      } else if(!formData.get('start_date') || !formData.get('start_time')){
        msg = 'From date and time is required.';
        status = false;
      } else if(!formData.get('end_date') || !formData.get('end_time')){
        msg = 'To date and time is required.';
        status = false;
      } else if(!formData.get('invoice_date')){
        msg = 'Invoice date is required.';
        status = false;
      } else if(!formData.get('payment_mode')){
        msg = 'Mode/Terms of payment is required.';
        status = false;
      } else {
        // Check if there are any selected retailers
        const selectedRetailers = retailerList.filter((retailer) => retailer?.selected === true);
        if(selectedRetailers.length === 0){
          msg = 'Please select at least one customer/retailer.';
          status = false;
        }
      }

      if(!status){
        notification.open({
          message: "Validation Error",
          description: msg,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 3,
        });
        setIsLoading(false);
        return;
      }

      // Get all selected retailers
      const updatedRetailerList = retailerList.filter((retailer) => retailer?.selected === true);
      
      // Track results
      let successCount = 0;
      let failureCount = 0;
      const results = [];

      // Process each selected user
      for(let i = 0; i < selectedUsers.length; i++){
        const user = selectedUsers[i];
        // Filter retailers for this specific user
        const userRetailers = updatedRetailerList.filter((retailer) => 
          retailer?.bind_person_id?.toString() === user?.users_id?.toString()
        );

        // Only process if user has selected retailers
        if(userRetailers.length > 0){
          const requestParams = {
            updatedRetailerList : userRetailers,
            users_oid : user._id,
            users_id : user.users_id,
            store : user.store_name || "N/A",
            users_name : `${user.users_name || ""} ${user.last_name || ""}`.trim() || "N/A",
            users_mobile : user.users_mobile || "N/A",
            invoice_date : formData.get('invoice_date'),
            payment_mode : formData.get('payment_mode'),
            start_date : formData.get('start_date'),
            end_date : formData.get('end_date'),
            start_time : formData.get('start_time'),
            end_time : formData.get('end_time'),
            add_in_due : formData.get('add_in_due') || 'N',
            export_type : formData.get('export_type') || 'PDF',
          };

          const result = await handleSubmit(requestParams);
          results.push(result);
          
          if(result.success){
            successCount++;
          } else {
            failureCount++;
          }
        }
      }
      // Show summary notification
      if(successCount > 0 && failureCount === 0){
        notification.open({
          message: "Success",
          description: `All ${successCount} request(s) processed successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
          duration: 3,
        });
        const batch_id_list = results.map(result => result.batch_id);
        navigate(`/invoice/retailers-list/${batch_id_list.join(',')}`);
      } else if(successCount > 0 && failureCount > 0){
        notification.open({
          message: "Partial Success",
          description: `${successCount} request(s) succeeded, ${failureCount} request(s) failed.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "orange" }} icon={faInfoCircle} />,
          duration: 4,
        });
      } else if(failureCount > 0){
        notification.open({
          message: "Error",
          description: `All ${failureCount} request(s) failed. Please check the details.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 4,
        });
      }

    } catch (error) {
      console.log("error", error);
      notification.open({
        message: "Error",
        description: "An unexpected error occurred. Please try again.",
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 3,
      });
    } finally {
      setIsLoading(false);
    }
  }
  
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (params={}) => {
    try {
      const { users_oid, users_id, store, users_name, users_mobile, invoice_date, payment_mode, start_date, end_date, start_time, end_time, add_in_due, export_type, updatedRetailerList } = params;
      let msg = "";
      let status = false;
      let batch_id = '';
      
      // Validation
      if(!users_oid || !users_id){
        msg = 'Please select at least one Sales Person.';
        return { success: false, message: msg };
      } else if(!start_date || !start_time){
        msg = 'From date and time is required.';
        return { success: false, message: msg };
      } else if(!end_date || !end_time){
        msg = 'To date and time is required.';
        return { success: false, message: msg };
      } else if(!invoice_date){
        msg = 'Invoice date is required.';
        return { success: false, message: msg };
      } else if(!payment_mode){
        msg = 'Mode/Terms of payment is required.';
        return { success: false, message: msg };
      } else if(!updatedRetailerList || updatedRetailerList.length === 0){
        msg = 'Please select at least one customer/retailer for this user.';
        return { success: false, message: msg };
      }

      // Prepare request data
      const combined_start_date = `${start_date} ${start_time}`;
      const combined_end_date = `${end_date} ${end_time}`;
      
      const requestData = {
        users_oid     : users_oid,
        users_id      : users_id,
        store         : store,
        users_name    : users_name,
        users_mobile  : users_mobile,
        invoice_date  : invoice_date,
        payment_mode  : payment_mode,
        start_date    : combined_start_date,
        end_date      : combined_end_date,
        start_time    : start_time,
        end_time      : end_time,
        add_in_due    : add_in_due || 'N',
        retailerList  : updatedRetailerList,
        invoice_number: updatedRetailerList.length || 0
      };

      if(export_type === 'PDF'){
        const res = await createRequest(requestData);
        if(res.status === true){
          batch_id = res?.result?.batch_no;
          status = true;
          msg = `Request sent successfully${batch_id ? ` (Batch: ${batch_id})` : ''}.`;
        } else {
          status = false;
          msg = res?.message || "Something went wrong.";
        }
      } else {
        // For Excel export, navigate to export page
        navigate("/invoice/export-excel", {state : requestData});
        return { success: true, message: "Redirecting to export page..." };
      }

      return { success: status, message: msg, batch_id: batch_id };
      
    } catch (error) {
      console.log("error", error);
      return { success: false, message: error?.message || "An unexpected error occurred." };
    }
  };

  const getUsersData = async (searchText='') =>{
    try {
      // Don't clear selected users when searching
      let searchString = searchText;
      let store_name, users_name, users_mobile, users_email;

      if(search_by === 'store_name'){
        store_name = { $regex: searchString, $options: "i" };
      } else if(search_by === 'users_name'){
        users_name = { $regex: searchString, $options: "i" };
      } else if(search_by === 'users_mobile'){
        users_mobile = parseInt(searchText);
      } else if(search_by === 'users_email'){
        users_email = { $regex: searchString, $options: "i" };
      } 

      const option = {
        condition : { 
          status : "A",
          ...(store_name?{store_name:store_name}:null),
          ...(users_name?{users_name:users_name}:null),
          ...(users_mobile?{users_mobile:users_mobile}:null),
          ...(users_email?{users_email:users_email}:null),
          users_type : {$nin : ['Retailer','Users','Promoter']}
        },
        select : { users_type : true, users_name : true, last_name : true, users_mobile : true, users_email : true, users_mobile : true, store_name : true, commission_percentage : true, users_id : true, pos_device_id : true, pos_number : true, area : true, bind_person_name : true },
        sort : {store_name : 1},
        limit : 1000
      }
      const res = await userList(option);
      if(res.status === true){
        setAllUsersList(res?.result || []);
      }
      setOptionsLoading(false);
    } catch (error) {
      
    }
  }
  const fetchGeneralData = async () =>{
    try {
      const option = {
        select :  {
          analyser_start_time     : true, 
          analyser_end_time       : true,
          invoice_start_time      : true, 
          invoice_end_time        : true
        }
      }
      const res = await getGeneralData(option);
      if(res?.status === true){
        setAddEditSata((pre)=>({
          ...pre,
          start_time : res?.result?.invoice_start_time || '21:30',
          end_time : res?.result?.invoice_end_time || "21:31"
        }))
      }
    } catch (error) {
      
    }
  }
  useEffect(() => {
    fetchGeneralData();
    getUsersData();
    document.title = `CRM U-Winn || Create Request`;
  }, []);

  const debounceTimeout = useRef(null);

  const handleSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      if (value.trim() !== "" && value.length > 3) {
        getUsersData(value);
      }
    }, 500); 
  };

  useEffect(()=>{
    if(ALLUSERSLIST.length > 0){
      const transformedArray = ALLUSERSLIST.map(user => ({
        label: `${user.users_name} | ${user.store_name} | ${user.users_mobile}`,
        value: JSON.stringify(user) 
      }));
      setOptions(transformedArray);
    }
  },[ALLUSERSLIST]);

  const handleUserChange = (values) =>{
    try {
      if (values && values.length > 0) {
        const usersData = values.map(value => JSON.parse(value));
        setSelectedUsers(usersData);
        // Keep the first selected user for backward compatibility with form fields
        if (usersData.length > 0) {
          const firstUser = usersData[0];
          setSelectedUser(firstUser);
          setInvoiceData((pre)=>({
            ...pre,
            store_name : firstUser?.store_name,
            user_name : `${firstUser?.users_name} ${firstUser?.last_name}`,
            mobile : firstUser?.users_mobile
          }))
        }
      } else {
        setSelectedUsers([]);
        setSelectedUser([]);
        setInvoiceData((pre)=>({
          ...pre,
          store_name : '',
          user_name : '',
          mobile : ''
        }))
      }
    } catch (error) {
      
    }
  }

  const getRetailerList = async () => {
    try {
      setCurrentPage(1);
      setSearchTerm(''); // Reset search when fetching new list
      setIsLoading(true);
      if (!selectedUsers || selectedUsers.length === 0) {
        setRetailerList([]);
        notification.open({
          message: "Error",
          description: "Please select at least one customer/retailer.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 3,
        });
        return;
      }
      // Get retailers for all selected users
      const userIds = selectedUsers.map(user => [user.users_id.toString(), parseInt(user.users_id)]);
      const option = {
        type : 'multiple',
        condition : { bind_person_id : { $in: userIds.flat() } },
        select : { store_name : true, users_name : true, users_mobile : true, users_id : true, pos_number : true, bind_person_name : true, bind_person_id : true, area : true },
        skip : 0,
        limit : 0
      }
      const res = await userList(option);
      if(res.status === true){
        setRetailerList(res.result);
        if(res.result.length === 0){
          notification.open({
            message: "Error",
            description: "No retailer found.",
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
            duration: 3,
          });
        }
      }else{
        setRetailerList([]);
        notification.open({
          message: "Error",
          description: "No retailer found.",
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 3,
        });
      } 
    } catch (error) {
      setIsLoading(false);
      setRetailerList([]);
    } finally {
      setIsLoading(false);
    }
  }
  const handleSelectRow = (id) => {
    setRetailerList((prev) =>
      prev.map((item) =>
        item._id === id ? { ...item, selected: !item.selected } : item
      )
    );
  }

  useEffect(()=>{
    // if(selectAll === true){
      setRetailerList((prev) =>
        prev.map((item) =>
          item._id?{ ...item, selected: selectAll } : item
        )
      );
    // }
  },[selectAll])

  // Reset to page 1 when retailerList changes
  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [retailerList]);

  // Filter retailer list based on search term
  const getFilteredRetailerList = () => {
    if (!searchTerm.trim()) {
      return retailerList;
    }
    
    const searchLower = searchTerm.toLowerCase().trim();
    return retailerList.filter((item) => {
      const storeName = item?.store_name?.toLowerCase() || '';
      const userName = item?.users_name?.toLowerCase() || '';
      const mobile = item?.users_mobile?.toString() || '';
      const bindPersonName = item?.bind_person_name?.toLowerCase() || '';
      
      return (
        storeName.includes(searchLower) ||
        userName.includes(searchLower) ||
        mobile.includes(searchLower) ||
        bindPersonName.includes(searchLower)
      );
    });
  };

  const filteredRetailerList = getFilteredRetailerList();

  // Calculate paginated data from filtered list
  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return filteredRetailerList.slice(startIndex, endIndex);
  };

  const paginatedRetailerList = getPaginatedData();
  const totalItems = filteredRetailerList.length;

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when search changes
  };

  // Reset form function
  const handleReset = () => {
    // Reset selected users
    setSelectedUsers([]);
    setSelectedUser([]);
    
    // Reset form data
    setAddEditSata({
      start_time: '21:31:00',
      end_time: '21:30:00'
    });
    setInvoiceData({});
    
    // Reset retailer list and related states
    setRetailerList([]);
    setSearchTerm('');
    setSelectAll(false);
    
    // Reset pagination
    setCurrentPage(1);
    setPageSize(10);
    
    // Reset search by
    setSearchBy('');
    
    // Reset errors
    setError({});
    
    // Reset form elements
    const form = document.querySelector('.inventory_form_main_contnet');
    if (form) {
      form.reset();
      // Manually reset select elements to their default values
      const searchBySelect = form.querySelector('#search_by');
      if (searchBySelect) {
        searchBySelect.value = '';
      }
      const paymentModeSelect = form.querySelector('#payment_mode');
      if (paymentModeSelect) {
        paymentModeSelect.value = '';
      }
      const addInDueSelect = form.querySelector('#add_in_due');
      if (addInDueSelect) {
        addInDueSelect.value = 'N';
      }
      const exportTypeSelect = form.querySelector('#export_type');
      if (exportTypeSelect) {
        exportTypeSelect.value = 'PDF';
      }
    }
    
    // Fetch default time values
    fetchGeneralData();
  };

  // Custom tag renderer to show only first 3 users, rest as +X
  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    const currentValue = value;
    const index = selectedUsers.findIndex(user => JSON.stringify(user) === currentValue);
    
    // Show only first 3 tags
    if (index < 3) {
      // Extract user name from label (format: "Name | Store | Mobile")
      const displayLabel = label ? label.split(' | ')[0] : label;
      return (
        <span
          style={{
            display: 'inline-block',
            margin: '2px 4px',
            padding: '2px 8px',
            background: '#f0f0f0',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            fontSize: '12px'
          }}
        >
          {displayLabel}
          {closable && (
            <span
              onClick={onClose}
              style={{
                marginLeft: '4px',
                cursor: 'pointer',
                color: '#999'
              }}
            >
              ×
            </span>
          )}
        </span>
      );
    }
    
    // For the 4th item, show +X format
    if (index === 3) {
      const remainingCount = selectedUsers.length - 3;
      return (
        <span
          style={{
            display: 'inline-block',
            margin: '2px 4px',
            padding: '2px 8px',
            background: '#f0f0f0',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            fontSize: '12px',
            cursor: 'default'
          }}
        >
          +{remainingCount}
        </span>
      );
    }
    
    // Don't render tags after the 4th one
    return null;
  };

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> Generate Invoice </h5>
          </React.Fragment>
          <Link to="/invoice/request">
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <FontAwesomeIcon icon={faArrowLeft} /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              {/* <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}> */}
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleBulkRequest}>
                <div className="row">
                  {/* Search By */}
                  <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="search_by" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                    </label>
                    <select title="Choose your option" name="search_by" id="search_by" className="form-control store_input_field" onChange={handleSearchBy}>
                      <option value="" selected disabled>Choose your option</option>
                      <option value="store_name">Store name</option>
                      <option value="users_name">Users name</option>
                      <option value="users_mobile">Users mobile</option>
                      <option value="users_email">Users email</option>
                    </select>
                  </div>

                  <div className="form-group col-lg-9 col-md-9 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Customer/Retailer :{" "}
                    </label>
                    <Select
                      className="form-control"
                      mode="multiple"
                      onSearch={handleSearch}
                      onChange={handleUserChange}
                      showSearch={true}
                      defaultOpen={true}
                      autoClearSearchValue={false}
                      placeholder="Search to Select"
                      notFoundContent={null}
                      loading={optionsLoading}
                      options={OPTIONS}
                      value={selectedUsers.map(user => JSON.stringify(user))}
                      tagRender={tagRender}
                    />
                    {error.admin_first_name ? (
                      <p style={{ color: "red" }}>{error.admin_first_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="start_date"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>From :{" "}
                    </label>
                    <input
                      type="date"
                      name="start_date"
                      max={today}
                      className="form-control store_input_field"
                      id="start_date"
                      onChange={handleChange}
                    />
                    {error.start_date ? (
                      <p style={{ color: "red" }}>{error.start_date}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="start_time"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>{" "}
                    </label>
                    <input
                      type="time"
                      name="start_time"
                      className="form-control store_input_field"
                      id="start_time"
                      value={ADDEDITDATA?.start_time}
                      onChange={handleChange}
                    />
                    {error.start_time ? (
                      <p style={{ color: "red" }}>{error.start_time}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-16 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="end_date"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>To :
                    </label> 
                    <input
                      type="date"
                      name="end_date"
                      className="form-control store_input_field"
                      id="end_date"
                      max={today}
                      onChange={handleChange}
                    />   
                    {error.end_date ? (
                      <p style={{ color: "red" }}>{error.end_date}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="end_time" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>{" "}
                    </label>
                    <input
                      type="time"
                      name="end_time"
                      className="form-control store_input_field"
                      id="end_time"
                      value={ADDEDITDATA?.end_time}
                      onChange={handleChange}
                    />
                    {error.end_time ? (
                      <p style={{ color: "red" }}>{error.end_time}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  {/* Store Name */}
                  {/* <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="admin_first_name" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Customer/Retailer's store :{" "}
                    </label>
                    <input
                      title="Customer/Retailer's Store."
                      placeholder="Customer/Retailer's store"
                      type="text"
                      name="store_name"
                      className="form-control store_input_field"
                      id="store_name"
                      value={invoiceData?.store_name || ''}
                      onChange={invoiceDataChange}
                    />
                    {error.store_name ? ( <p style={{ color: "red" }}>{error.store_name}</p> ) : ( "" )}
                  </div> */}
                  
                  {/* User's Name */}
                  {/* <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="user_name" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Name :{" "}
                    </label>
                    <input
                      title="User's Name."
                      placeholder="Customer/Retailer's name"
                      type="text"
                      name="user_name"
                      className="form-control store_input_field"
                      id="user_name"
                      value={invoiceData?.user_name || ''}
                      onChange={invoiceDataChange}
                    />
                    {error.user_name ? ( <p style={{ color: "red" }}>{error.user_name}</p> ) : ( "" )}
                  </div> */}
                  {/* User's Mobile */}
                  {/* <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="mobile" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Mobile no. :{" "}
                    </label>
                    <input
                      title="Mobile No."
                      placeholder="Mobile No."
                      type="text"
                      name="mobile"
                      className="form-control store_input_field"
                      id="mobile"
                      value={invoiceData?.mobile}
                      onChange={invoiceDataChange}
                    />
                    {error.mobile ? ( <p style={{ color: "red" }}>{error.mobile}</p> ) : ( "" )}
                  </div> */}
                  
                  {/* Invoice Date */}
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="invoice_date" className="all_section_for_label_main_class" ><span style={{ color: "red" }}>*</span>Invoice date :</label>
                    <input
                      title="Invoice Date"
                      placeholder="Invoice Date"
                      type="date"
                      name="invoice_date"
                      className="form-control store_input_field"
                      id="invoice_date"
                      value={invoiceData?.invoice_date || ''}
                      onChange={invoiceDataChange}
                    />
                    {error.invoice_date ? ( <p style={{ color: "red" }}>{error.invoice_date}</p> ) : ( "" )}
                  </div>
                  {/* payment mode */}
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="payment_mode" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Mode/Terms of payment :{" "}
                    </label>
                    <select name="payment_mode" id="payment_mode" className="form-control store_input_field" onChange={invoiceDataChange} >
                      <option value='' selected disabled >Choose your options</option>
                      <option value='Cash' >Cash</option>
                      <option value='Online' >Online</option>
                    </select>
                    {error.payment_mode ? ( <p style={{ color: "red" }}>{error.payment_mode}</p> ) : ( "" )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="payment_mode" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Add in due :{" "}
                    </label>
                    <select name="add_in_due" id="add_in_due" className="form-control store_input_field" onChange={invoiceDataChange} >                      
                      <option value='N' selected >No</option>
                      <option value='Y' >Yes</option>
                    </select>
                    {error.payment_mode ? ( <p style={{ color: "red" }}>{error.payment_mode}</p> ) : ( "" )}
                  </div>

                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="export_type" className="all_section_for_label_main_class" >
                      <span style={{ color: "red" }}>*</span>Export type:{" "}
                    </label>
                    <select name="export_type" id="export_type" className="form-control store_input_field" onChange={invoiceDataChange} >                      
                      <option value='Excel' >Excel</option>
                      <option value='PDF' selected >PDF</option>
                    </select>
                    {error.payment_mode ? ( <p style={{ color: "red" }}>{error.payment_mode}</p> ) : ( "" )}
                  </div>

                </div>

                <div className="inventory_edit_submit_btn">
                  <button type="button" className="btn btn-primary inventory_save_button" onClick={getRetailerList} > Get Retailer's List </button>
                  <button type="button" className="btn btn-secondary inventory_save_button" onClick={handleReset} style={{ marginLeft: '10px' }}> Reset </button>
                </div>
                <div className="row">
                  {retailerList.length > 0 && (
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data" style={{ marginBottom: '16px' }}>
                      <Input
                        placeholder="Search by store name, customer name, mobile, or bind person name..."
                        allowClear
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ width: '100%' }}
                        prefix={<FontAwesomeIcon icon={faSearch} style={{ color: '#bfbfbf' }} />}
                      />
                    </div>
                  )}
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellspacing="0"
                    >
                      <thead>
                        <tr>
                          <th onClick={toggleSelectAll} ><input type="checkbox" checked={selectAll} className="store_input_field"/> Sl. No.</th>
                          <th>Customer/Retailer</th>
                          <th>Bind Person Name</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                      {paginatedRetailerList?.length > 0 ? (
                          paginatedRetailerList.map((items, index) => {
                            const actualIndex = (currentPage - 1) * pageSize + index;
                            return (
                              <tr key={items._id || index} onClick={()=>handleSelectRow(items._id)}>
                                <td>
                                  {actualIndex + 1} {"  "}
                                  <input type="checkbox" checked={items?.selected === true?true:false} className="store_input_field"/>
                                </td>

                                <td className="admin_user_list_date"> 
                                  <span>Store : {items?.store_name}</span><br/>
                                  <span>Name : {items?.users_name}</span><br/> 
                                  <span>Mobile : {items?.users_mobile}</span>
                                </td>
                                <td className="admin_user_list_date"> {items?.bind_person_name}</td>

                                <td className="admin_user_list_date"> Pending </td>
                              </tr>
                            );
                          })
                        ) : isLoading ? <></> : <tr> 
                            <td colSpan="4" className="img-center" >No data found !</td> 
                        </tr>}
                      </tbody>
                    </table>
                    {totalItems > 0 && (
                      <div style={{ marginTop: '16px', marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={totalItems}
                          onChange={handlePageChange}
                          onShowSizeChange={handlePageChange}
                          showSizeChanger
                          showQuickJumper
                          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                          pageSizeOptions={['10', '20', '50', '100']}
                        />
                      </div>
                    )}
                    {retailerList.length > 0 && (
                    <div className="inventory_edit_submit_btn">
                      <button type="submit" className="btn btn-primary inventory_save_button"> Generate Request </button>
                    </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} text={loadingText} />
    </div>
  );
};

export default UserListEditPage;
